import merge from 'deepmerge';
import BaseParser from './BaseParser';
import VASTParser from './VASTParser';
import { update } from 'Emitter';
import { CONFIGURATION } from 'StateEvents';
import * as MediaFormats from 'Media/MediaFormats';

const MAX_WRAPPER_DEPTH = 3;

export default class AcuityConfigParser extends BaseParser {
  constructor() {
    super();
  }

  async onUpdate(newState, prevState, changes) {
    if(changes.host.creativeData.AdParameters && newState.host.creativeData.AdParameters) {
      const parsed = await this.parse(newState.host.creativeData.AdParameters);
      update(CONFIGURATION.UPDATED, 'onUpdate', parsed);
    }
  }

  async parse(src) {
    let parsed = {};

    try {
      parsed = JSON.parse(src);
      parsed = await this.parseRemoteMedia(parsed);
      return parsed;
    } catch(e) {
      if(parsed && parsed.Media) {
        parsed.Media.length = 0; // ensure the media handler doesn't try to load any media
      }
      update(CONFIGURATION.UPDATED, 'onUpdate', parsed); // store any config that might have been parsed
      console.error(e);
      throw new Error(`config parser error. ${e}`);
    }
  }

  async parseRemoteMedia(parsed, depth = 0) {
    let merged = parsed, vastTag, vastConfig;

    if((vastTag = parsed.Media && parsed.Media.find( item => item.format === MediaFormats.VAST)) && depth < MAX_WRAPPER_DEPTH) {
      vastConfig = await new VASTParser(vastTag.src).toConfig();
      const media = vastConfig.Media;
      merged = merge(parsed, vastConfig);
      merged.Media = media;
      merged.UI.click = merged.UI.click || parsed.UI.click;

      // continue parsing tag until non-VAST media is found
      merged = await this.parseRemoteMedia(merged, depth + 1);
    }

    return merged;
  }

  stripParsedVAST(media) {
    return media.filter( m => m.format !== MediaFormats.VAST);
  }
}


// WEBPACK FOOTER //
// ./src/Services/Parsers/AcuityConfigParser.js